var initState = {
  locale: 'en',
  metamask: {},
  userAuth: {}
}

export default initState